import { onCLS, onLCP, onINP, onFCP, onTTFB } from 'web-vitals';
import ReactGA from 'react-ga4';
import { hasAnalyticsConsent } from './consent';

const canTrack = () =>
  process.env.REACT_APP_GA_MEASUREMENT_ID && hasAnalyticsConsent();

const METRIC_NAMES = {
  CLS: 'Cumulative Layout Shift',
  LCP: 'Largest Contentful Paint',
  INP: 'Interaction to Next Paint',
  FCP: 'First Contentful Paint',
  TTFB: 'Time to First Byte',
};

const sendToGA = (metricName, value, rating) => {
  if (!canTrack()) return;

  ReactGA.gtag('event', 'web_vitals', {
    event_category: 'Web Vitals',
    event_label: metricName,
    metric_name: metricName,
    metric_display_name: METRIC_NAMES[metricName] || metricName,
    metric_value: Math.round(metricName === 'CLS' ? value * 1000 : value),
    metric_rating: rating,
    value: Math.round(metricName === 'CLS' ? value * 1000 : value),
    non_interaction: true,
  });
};

onCLS((metric) => sendToGA('CLS', metric.value, metric.rating));
onLCP((metric) => sendToGA('LCP', metric.value, metric.rating));
onINP((metric) => sendToGA('INP', metric.value, metric.rating));
onFCP((metric) => sendToGA('FCP', metric.value, metric.rating));
onTTFB((metric) => sendToGA('TTFB', metric.value, metric.rating));